import {
  SCHEDULE_SLOT_SPAN
} from '../../config/constants'

export default () => {
  const slotSpanMinutes = SCHEDULE_SLOT_SPAN
  const endOfDay = 24 * 60

  let slots = []

  for (let i = 0; i < endOfDay; i += slotSpanMinutes) {
    slots.push({available: false})
  }

  return slots
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/helpers/get_empty_daily_availability_slots.js
 **/